import { useMutation, useQuery } from '@tanstack/react-query';
import { deleteAuthenticationMethods, postAuthenticationMethodEnrollments } from '#/api/apiClient';
import { authenticationQueries } from '#/api/queryKeys/authenticationKeys';

export type AuthenticationMethodEnrollmentsProps = ReturnType<typeof useAuthenticationMethodEnrollments>;

export function useAuthenticationMethodEnrollments() {
  const { isSuccess, mutateAsync, error } = useMutation({ mutationFn: () => postAuthenticationMethodEnrollments() });
  return {
    postMfaUrl: mutateAsync,
    isSuccess,
    error,
  };
}

export function useAuthenticationMethods() {
  const { data, error } = useQuery({ ...authenticationQueries.list() });
  return { data: data?.data, error };
}

export function useDeleteAuthenticationMethods() {
  const { isSuccess, mutateAsync, error } = useMutation({
    mutationFn: (id: string) => deleteAuthenticationMethods(id),
  });
  return {
    deleteMfa: mutateAsync,
    isSuccess,
    error,
  };
}
